import { buildStaffMenu } from "./staffMenu"
// Also available for Corporate Communication-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Corporate Communication role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add Corporate Communication-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildCorpMenu = () => buildStaffMenu()
